import { format, isBefore, isAfter, isSameYear, isSameMonth, differenceInDays } from 'date-fns';

export function formatEventDates(start: string, end: string): string {
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startFormatted = format(startDate, 'MMMM do');

    if (isSameYear(startDate, endDate) && isSameMonth(startDate, endDate)) {
      return `${startFormatted} to ${format(endDate, 'do')}`;
    }

    return `${startFormatted} to ${format(endDate, 'MMMM do')}`;
  } catch {
    return `${start} to ${end}`;
  }
}

export function daysToEvent(start: string, end: string): number {
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const now = new Date();

    if (isAfter(now, endDate) || isBefore(endDate, now)) {
      return Math.abs(differenceInDays(now, endDate));
    }

    if (isBefore(now, startDate) || isAfter(startDate, now)) {
      return Math.abs(differenceInDays(startDate, now));
    }

    return 0;
  } catch {
    return 9999;
  }
}

export function getEventSubText(start: string, end: string): string {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const now = new Date();

  const pastEvent = now >= endDate;
  const futureYear = startDate.getFullYear() > now.getFullYear();
  const currentYear = startDate.getFullYear() === now.getFullYear();

  if (pastEvent && currentYear) {
    return 'over';
  }

  if (futureYear || pastEvent) {
    return String(startDate.getFullYear());
  }

  return '';
}

export function isGuestSalesActive(event: { app_enable?: string; start: string; end: string }): boolean {
  const start = new Date(event.app_enable || event.start).valueOf();
  const end = new Date(event.end).valueOf();
  const now = Date.now();

  if (isNaN(start) || isNaN(end)) {
    console.error('Error checking if guest sales should be active');
    return false;
  }

  return start <= now && now < end;
}

export function formatVid(vid: string | undefined): string {
  if (typeof vid !== 'string') return '(missing)';

  let remaining = vid;
  let newStr = '';

  while (remaining.length >= 8) {
    newStr += remaining.substring(0, 4) + ' ';
    remaining = remaining.substring(4);
  }
  newStr += remaining;

  return newStr;
}
